import { Divider, Typography } from '@mui/material';
import { FC } from 'react';

interface IModalTitle {
  title: string;
  titleMarginBottom?: number;
}

export const ModalTitle: FC<IModalTitle> = ({ title, titleMarginBottom = 0 }) => {
  return (
    <>
      <Typography sx={theme => ({ marginBottom: titleMarginBottom })} variant="h6" component="p">
        {title}
      </Typography>
      <Divider />
    </>
  );
};
